import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBounsPointerSettings, changeBounsPointerSettings } from '@/api/modules/bonusPointsSettings'

export const getBounsPointerSettingsAction = createAsyncThunk(
    "getBounsPointerSettings",
    async () => {
        // getUserChannels函数是一个axios的请求
        const result = await getBounsPointerSettings();
        if (!result.error) return result.data;
        else {
            return Promise.reject(result.error);
        }
    }
)

export const changeBounsPointerSettingsAction = createAsyncThunk(
    "changeBounsPointerSettings",
    async (params: any) => {
        // getUserChannels函数是一个axios的请求
        const result = await changeBounsPointerSettings(params);
        if (result.data) return result.data;
    }
)